<script setup>

import { 
	InformationCircleIcon,
	CheckCircleIcon,
	XCircleIcon
} from "@heroicons/vue/solid"

import Form from '@/Pages/Public/MembershipApplication/Form'

import { Inertia } from '@inertiajs/inertia'

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()
import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

const props = defineProps({
	application: {
		type: Object, // an inertia form helper
		default: () => ({}),
	},
	membershipTiers: {
		type: Array,
		required: true,
	},
	paymentFrequencies: {
		type: Array,
		required: true,
	},
})

function deny(){
	Inertia.post('/membership-applications/' + props.application.id, {
		_method: 'PUT',
		status: 'DENIED',
	})
}

function approve(){
	Inertia.post('/membership-applications/' + props.application.id, {
		_method: 'PUT',
		status: 'APPROVED',
	})
}

</script>

<template>
	<Form
		:fields="application"
		:membership-tiers="membershipTiers"
		:payment-frequencies="paymentFrequencies"
		:disabled="true"
	>

		<template #header>
			<div class="flex flex-row justify-between">
				<div v-if="application.status == 'SUBMITTED'" class="flex flex-row items-center">
					<InformationCircleIcon class="h-10 w-10 mr-2 text-Orange" />
					<div class="flex flex-col">
						<div class="flex flex-row">Status: <span class="text-Orange ml-1">Submitted</span></div>
						<span class="text-sm font-medium text-gray-900">Awaiting Approval</span>
					</div>
				</div>

				<div v-if="application.status == 'APPROVED'" class="flex flex-row items-center">
					<CheckCircleIcon class="h-10 w-10 mr-2 text-Green" />
					<div class="flex flex-col">
						<div class="flex flex-row">Status: <span class="text-Green ml-1">Approved</span></div>
						<span class="text-sm font-medium text-gray-900">Membership has been approved</span>
					</div>
				</div>

				<div v-if="application.status == 'DENIED'" class="flex flex-row items-center">
					<XCircleIcon class="h-10 w-10 mr-2 text-Red" />
					<div class="flex flex-col">
						<div class="flex flex-row">Status: <span class="text-Red ml-1">Denied</span></div>
						<span class="text-sm font-medium text-gray-900">Membership has been denied</span>
					</div>
				</div>

				<div class="flex flex-row items-end">
					View Organisation: <Link class="ml-2" :href="'/organisations/' + application.organisation_id">{{ application.name }}</Link>
				</div>
			</div>
		</template>

		<template #footer>
			<Button
				class="mr-2"
				:status="application.status != 'SUBMITTED' ? 'disabled' : null"
				@click="deny"
				color="red"
				variant="link"
				data-testid="deny"
			>
				Deny
			</Button>
			
			<Button
				:status="application.status != 'SUBMITTED' ? 'disabled' : null"
				@click="approve"
				color="green"
				data-testid="approve"
			>
				Approve
			</Button>
		</template>
	</Form>
</template>